import TextField from '@material-ui/core/TextField';
import styled, { css } from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  margin-bottom: 16px;
`;

const TextStyle = css`
  font-family: Poppins;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

const LabelStyle = css`
  font-family: Poppins;
  font-size: 14px;
  line-height: 1.43;
  color: ${ColorPalette.HEX.DimGray};
`;

export const StyledInput = styled(TextField)`
  & > div > input,
  textarea {
    ${TextStyle}
    padding: 16px 0 10px 16px;
  }

  & > label {
    ${LabelStyle}
  }

  & > label.Mui-focused {
    ${LabelStyle}
  }

  & > div > div {
    ${TextStyle}
    padding: 16px 0 10px 16px;
  }

  & > div::after {
    border-bottom-color: ${ColorPalette.HEX.CharlestonGreen};
  }
`;
